import produce, { Draft } from 'immer';
import { getType } from 'typesafe-actions';

import { getCreativeImageCropError } from '../CreativeImageCropHelper/CreativeImageCropHelper';

import {
    closeModal,
    CreativeSmartCenterModalAction,
    cropComplete,
    init,
    openModal,
    saveModal,
    setImageSize,
    showError
} from './actions';
import { getAdaptiveImageCropData, getAdaptiveImageCropValue, getRealImageCrop } from './helpers';
import { CreativeSmartCenterModalState } from './typings';

export const creativeSmartCenterModalInitialState = {
    isVisible: false,
    isLoading: false,
    error: undefined
};

export function creativeSmartCenterModal(
    state: CreativeSmartCenterModalState = creativeSmartCenterModalInitialState,
    action: CreativeSmartCenterModalAction
): CreativeSmartCenterModalState {
    return produce(state, (draft: Draft<CreativeSmartCenterModalState>) => {
        switch (action.type) {
            case getType(openModal): {
                draft.isVisible = true;
                draft.isLoading = true;

                return;
            }

            case getType(init): {
                const { cropValue, imageData } = action;

                draft.imageData = imageData;
                draft.cropValue =
                    cropValue && imageData.realImageSize
                        ? {
                              // с бека приходят данные кропа для уменьшенной версии
                              crop: getRealImageCrop(imageData.realImageSize, cropValue.crop)
                          }
                        : undefined;

                return;
            }

            case getType(setImageSize): {
                const { naturalImageSize } = action;
                const { cropValue, imageData } = draft;

                if (!imageData) {
                    throw "Couldn't find imageData!";
                }

                if (imageData.naturalImageSize) {
                    return;
                }

                draft.cropValue = getAdaptiveImageCropValue(naturalImageSize, imageData, cropValue);
                draft.cropData = getAdaptiveImageCropData(naturalImageSize, draft.cropValue);
                imageData.naturalImageSize = naturalImageSize;
                draft.isLoading = false;

                return;
            }

            case getType(closeModal): {
                return creativeSmartCenterModalInitialState;
            }

            case getType(cropComplete): {
                const { cropData } = draft;
                if (cropData) {
                    cropData.crop = action.crop;
                } else {
                    draft.cropData = {
                        crop: action.crop
                    };
                }
                draft.error = undefined;

                return;
            }

            case getType(saveModal): {
                draft.isLoading = true;
                draft.error = undefined;

                return;
            }

            case getType(showError): {
                draft.error = getCreativeImageCropError(action.message);
                draft.isLoading = false;

                return;
            }

            default:
                return state;
        }
    });
}
